import { Instagram, Facebook, Heart, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-deepbrown text-ivory mt-24">
      <div className="yarn-divider" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="h-16 w-16 rounded-full bg-ivory grid place-items-center overflow-hidden shadow-md p-1" data-testid="footer-logo">
              <img
                src="https://customer-assets.emergentagent.com/job_yarn-market-in/artifacts/1x2gpo9a_ChatGPT%20Image%20Jun%2029%2C%202026%2C%2009_03_28%20PM.png"
                alt="Sutrakosh by Chanchala"
                className="h-full w-full object-contain"
              />
            </div>
            <div className="font-display font-bold leading-tight">
              <p className="text-2xl">Sutrakosh</p>
              <p className="text-[11px] tracking-widest text-marigold uppercase">by Chanchala</p>
            </div>
          </div>
          <p className="text-ivory/70 text-sm leading-relaxed">
            Handmade with love in India. Every stitch tells a story.
          </p>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4 text-marigold">Shop</h4>
          <ul className="space-y-2 text-sm text-ivory/80">
            <li><a href="/shop" className="hover:text-rani">Shop All</a></li>
            <li><a href="/shop?category=home-decors" className="hover:text-rani">Home Decors</a></li>
            <li><a href="/shop?category=accessories" className="hover:text-rani">Accessories</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4 text-marigold">Help</h4>
          <ul className="space-y-2 text-sm text-ivory/80">
            <li>Shipping & Returns</li>
            <li>Care Instructions</li>
            <li>Custom Orders</li>
            <li>Contact Us</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-4 text-marigold">Newsletter</h4>
          <p className="text-sm text-ivory/70 mb-3">Get 10% off your first order.</p>
          <form className="flex" onSubmit={(e) => e.preventDefault()}>
            <input
              type="email"
              placeholder="your@email.com"
              className="flex-1 px-3 py-2 rounded-l-full text-deepbrown text-sm outline-none"
              data-testid="newsletter-input"
            />
            <button
              type="submit"
              className="px-4 bg-rani rounded-r-full text-sm font-bold hover:bg-rani/90"
              data-testid="newsletter-submit"
            >
              <Mail className="h-4 w-4" />
            </button>
          </form>
          <div className="flex gap-3 mt-6">
            <a href="#" className="h-9 w-9 rounded-full bg-ivory/10 grid place-items-center hover:bg-rani"><Instagram className="h-4 w-4" /></a>
            <a href="#" className="h-9 w-9 rounded-full bg-ivory/10 grid place-items-center hover:bg-rani"><Facebook className="h-4 w-4" /></a>
          </div>
        </div>
      </div>

      <div className="border-t border-ivory/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-ivory/60">
          <p>© 2026 Sutrakosh by Chanchala · <a href="https://www.chanchalahandmade.com" className="hover:text-rani">www.chanchalahandmade.com</a> · Crafted with <Heart className="inline h-3 w-3 text-rani" /> in India</p>
          <p>Razorpay secured payments · COD available</p>
        </div>
      </div>
    </footer>
  );
}
